import { RefObject } from "react";

export default function scrollToFirstError(ref: RefObject<HTMLDivElement>) {
    ref.current
        ?.querySelector("[data-invalid=true]")
        ?.scrollIntoView({ behavior: "smooth" });
}
